<template>
  <BittsSelect
    v-model="pickedSalesRole"
    class="c-select-sales-role"
    data-testid="sales-role-selector"
    form-label="Sales Role"
    placeholder="Select Sales Role"
    :options="salesRoleOptions"
  />
</template>

<script setup>
import { BittsSelect } from '@crossbeam/bitts';

import { computed, watch } from 'vue';

import {
  CO_SELLER,
  NO_ACCESS,
  PARTNER_MANAGER,
  VIEWER,
} from '@/constants/team'; // TODO: Migrate SE Roles
import { CORE, OLD_ROLES_TO_NEW_MAP } from '@/constants/team_v4';

const props = defineProps({
  modelValue: {
    type: [String, null],
    default: null,
  },
  pickedSeat: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const pickedSalesRole = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

/* No Access is only a valid sales role for a Core seat, so clear it
whenever the seat is anything else. This must run immediately (not
just on change): the parent unmounts this component while the
Integration seat is selected, so switching back to Sales mounts a
fresh instance that never sees a "changed to non-Core" transition -
it just starts out already non-Core with the stale value. */
const isCoreSeatSelected = computed(() => props.pickedSeat?.value === CORE);
watch(
  () => props.pickedSeat?.value,
  () => {
    if (!isCoreSeatSelected.value && pickedSalesRole.value === NO_ACCESS)
      pickedSalesRole.value = undefined;
  },
  { immediate: true },
);

const salesRoleOptions = computed(() => {
  const options = [PARTNER_MANAGER, CO_SELLER, VIEWER].map((role) => ({
    value: role,
    label: OLD_ROLES_TO_NEW_MAP[role].label,
  }));
  if (props.pickedSeat?.value === CORE)
    options.push({ value: NO_ACCESS, label: 'No Access' });
  return options;
});
</script>
